import { computed, MaybeRefOrGetter, ref, toRef } from 'vue';

export function useExpandAllPanels(items: MaybeRefOrGetter<any[] | undefined>) {
  const itemsRef = toRef(items);
  const expandedIndices = ref<number[]>([]);

  function expandAll() {
    expandedIndices.value = itemsRef.value?.map((_, index) => index) ?? [];
  }

  function collapseAll() {
    expandedIndices.value = [];
  }

  const allExpanded = computed(() => itemsRef.value?.length === expandedIndices.value.length);

  const anyExpanded = computed(() => !!expandedIndices.value.length);

  return {
    expandedIndices,
    expandAll,
    collapseAll,
    allExpanded,
    anyExpanded,
  };
}
